import React from 'react';
import "./index.css";
import {Routes} from "../../../common/Routes";
import {useHistory} from "react-router-dom";
import {ManagePolicyController} from "./controller";
import {Spin} from "antd";

interface PolicyManageResultProps {
  policyName: string;
  setCurrent: (value: number) => void;
}

const PolicyManageResult: React.FC<PolicyManageResultProps> = ({policyName, setCurrent}) => {
  const {
    createPolicyPEV,
    editPolicyPEV,
  } = ManagePolicyController();

  const history = useHistory();

  const handleClickPoliciesList = () => {
    history.push(`${Routes.Policies.path}`);
  }

  return (
    <div className={"policyResultContainer"}>
      {createPolicyPEV.progress === null ?
        <>{
          createPolicyPEV.error === null ?
            <div className={"policyCreatingSuccessInfo"}>
              Policy "{policyName}" created successfully!
            </div> :
            <div className={"policyCreatingSuccessInfo"}>
              Policy "{policyName}" creation failed!
            </div>
        }
          <div>
            <p>
              Back to&nbsp;
              <span
                style={{textDecoration: 'underline', color: '#333', cursor: 'pointer'}}
                onClick={handleClickPoliciesList}
              > Policies list
              </span>
              &nbsp;or go to&nbsp;Policy {policyName}&nbsp;creation page
            </p>
          </div>
        </> : (editPolicyPEV.progress === null ?
              <>
                {
                  editPolicyPEV.error === null ?
                    <div className={"policyCreatingSuccessInfo"}>
                      Policy "{policyName}" updated successfully!
                    </div> :
                    <div className={"policyCreatingSuccessInfo"}>
                      Policy "{policyName}" updation failed!
                    </div>
                }
                  <div>
                    <p>
                      Back to&nbsp;
                      <span
                        style={{textDecoration: 'underline', color: '#333', cursor: 'pointer'}}
                        onClick={handleClickPoliciesList}
                      > Policies list
                      </span>
                    </p>
                  </div>
              </> : (<Spin/>)
        )
      }
    </div>
  );
};

export default PolicyManageResult;